import { ADD_AVATAR, DELETE_AVATAR } from "./avatar.types";

export const addAvatar = (id, body, type) => {
  return {
    type: ADD_AVATAR,
    payload: {
      id,
      body,
      type
    },
  };
};

export const deleteAvatar = (id, type) => {
  return {
    type: DELETE_AVATAR,
    payload: {
      id,
      type
    },
  };
};
